import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { ScheduleModule } from '@nestjs/schedule';
import { TypeOrmModule } from '@nestjs/typeorm';
import { IndentFormAdapter } from './indent-form.adapter';
import { PackingIndentController } from './indent.controller';
import { PackingIndentService } from './indent.service';
import { PackingIndent } from './packing-indent.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([PackingIndent]),
    ScheduleModule.forRoot(),

  ],
  controllers: [PackingIndentController],
  providers: [PackingIndentService,IndentFormAdapter,ApplicationExceptionHandler],
  exports: [PackingIndentService]
})
export class PackingIndentModule {}
